import { render, staticRenderFns } from "./StatsLostProspectsClients.vue?vue&type=template&id=2a02bd4b"
import script from "./StatsLostProspectsClients.vue?vue&type=script&lang=js"
export * from "./StatsLostProspectsClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports